export default "__VITE_ASSET__CdWORFeC__"